import { useState } from "react";
import { Link, withRouter } from "react-router-dom";

import { useTranslation } from "react-i18next";
import FeedbackLogs from "../../components/Communications/Feedback/FeedbackLogs";
import InstructionsList from "../../components/Communications/InstructionsList";
import PageShell from "../../components/UI/PageShell";

const Communications = ({ history }) => {
  const { t } = useTranslation();
  const tabs = ["Feedback", "Instructions"];
  const [activeTab, setActiveTab] = useState(tabs[0]);

  return (
    <PageShell
      title={t("Communications")}
      eyebrow="Inbox & support"
      description="Read workplace instructions and keep track of your feedback."
    >
      <div className="portal-content-card">
        <div className="portal-tabs" role="tablist" aria-label="Communication sections">
          {tabs.map((tab, index) => (
            <button
              type="button"
              key={index}
              className={`portal-tab${activeTab === tab ? " is-active" : ""}`}
              onClick={() => setActiveTab(tab)}
              role="tab"
              aria-selected={activeTab === tab}
            >
              {t(tab)}
            </button>
          ))}
        </div>
        {activeTab === "Feedback" && <FeedbackLogs />}
        {activeTab === "Instructions" && <InstructionsList />}
      </div>
    </PageShell>
  );
};

export default withRouter(Communications);
